import { AWS_API_URL } from 'global/environment';
import { authorize, getRequest } from 'utils/http';

export async function getAssetsAPI() {
  const url = `${AWS_API_URL}/assets`;
  return getRequest(url, await authorize());
}
